import { render, staticRenderFns } from "./GlobalData.vue?vue&type=template&id=0aac3872&"
import script from "./GlobalData.vue?vue&type=script&lang=js&"
export * from "./GlobalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports